import React from 'react';
import { Cell } from 'react-foundation';

const DecisionInfo = ({ decisionData }) => {
    var decisionDate = "";

    if (decisionData.requestDate !== undefined) {
        const jsDate = new Date(decisionData.decisionDate);
        decisionDate = new Intl.DateTimeFormat('en-US').format(jsDate);
    }

    if (decisionData.status !== "Submitted") {
        return (
            <>
                <Cell medium={6} large={6} small={6} className="form-label">Decision Date</Cell>
                <Cell medium={6} large={6} small={6}>{decisionDate}</Cell>
            </>
        );
    }
    else {
        return (
            <>
            </>);
    }
};

export default DecisionInfo;